export const offersScrollFrag = `
    id
    name
    code
    color
    usualTime
    unit
    noRecord
    operations(input: { validAt: "VALID_AT" }) {
        id
        name
        type
    }
    procedures(input: { validAt: "VALID_AT" }) {
        id
        name
        winCarolCode
        customCode
    }
`;

export const waitingListOffersFrag = `
    id
    folderId
    dateFrom
    dateTo
    offerId
    offer {
        id
        name
        code
        color
    }
    applications
    operations
    procedures
`;
